import React, { useEffect, useState } from 'react';
import MeetingOrderForm from 'component/MeetingOrderForm';
import Breadcrumb from 'component/Breadcrumb';
import { getPageFrom } from 'util/meeting';
import { useHistory } from 'react-router-dom';
import { RootState } from 'model';
import { useDispatch, useSelector } from 'react-redux';
import styles from './index.module.scss';
import { IMeetingOrderForm, IMeetingOrderFn } from 'type/meeting';
import { orderMeeting, resetConflictSchedules, resetMeetingOrderParams } from 'model/meeting';
import { IMeetingDetail } from 'type/meetingDetail';
import container from 'lib/container';
import qs from 'qs';
import { formatBookTime } from 'util/format';

const OrderMeeting: React.FC = () => {
  const history = useHistory();
  const query = qs.parse(location.search.slice(1));

  const dispatch = useDispatch();
  const [crumbItems, setCrumbItems] = useState<{ path?: string; label: string }[]>([]);
  const [formValue, setFormValue] = useState<Partial<IMeetingOrderForm>>();
  const meetingOrderParams = useSelector((state: RootState) => state.meeting.meetingOrderParams);

  const onConfirm: IMeetingOrderFn = (meeting) => {
    return new Promise((resolve) => {
      dispatch(
        orderMeeting({
          meeting,
          onSuccess: (meeting: IMeetingDetail) => {
            container.sdk?.createMeetingSuccess(meeting.meetingNo);
            resolve({ success: true });
          },
          onFail: (err: any) => {
            if (err?.response?.data?.code === 400403002) {
              const data = err?.response?.data?.data;
              resolve({ success: false, data: data });
            } else if (err?.response?.data?.code === 400406011) {
              resolve({ success: false, errMesaage: '预约人（部门）、会议主题、会议地点可能包含涉黄/涉暴/政治/敏感信息，请检查后重试' });
            } else {
              resolve({ success: false, data: null });
            }
          }
        })
      );
    });
  };

  const onCancel = () => {
    // 对接迈聆 - 取消预约后执行
    container.sdk?.cancelCreateMeeting();

    history.goBack();
  };

  const getAndResetMeetingParams = () => {
    if (meetingOrderParams) {
      setFormValue(meetingOrderParams);
      // 清除会议参数
      dispatch(resetMeetingOrderParams());
    } else if (query?.startTime || query?.endTime || query?.subject) {
      const bookTime = formatBookTime(query.startTime as string, query.endTime as string);
      setFormValue({ ...bookTime, subject: (query.subject as string) || '' });
    }
  };

  useEffect(() => {
    setCrumbItems([getPageFrom(), { label: '会议预约' }]);
    getAndResetMeetingParams();
    return () => {
      dispatch(resetConflictSchedules());
    };
  }, []);

  return (
    <>
      <Breadcrumb items={crumbItems} />
      <div className={styles.body}>
        <MeetingOrderForm title="预约会议" formType="order" formValue={formValue} onConfirm={onConfirm} onCancel={onCancel} confirmText="发出预约" />
      </div>
    </>
  );
};

export default OrderMeeting;
